import Image from "next/image";

export function RedirectLayout({
  appIconSrc,
  appName,
  children,
}: {
  appIconSrc: string | null;
  appName: string | null;
  children: React.ReactNode;
}) {
  return (
    <div
      className={`
        no-layout-border flex min-h-dvh flex-col items-center justify-center gap-6 bg-white
        font-medium text-slate-900
        system-dark:bg-black system-dark:text-white
      `}
    >
      {appIconSrc && (
        <Image
          src={appIconSrc}
          alt="application icon"
          width={96}
          height={96}
          priority
          className="rounded-2xl"
        />
      )}
      {appName && <p className="text-lg font-semibold">{appName}</p>}
      {children}
    </div>
  );
}
